import React, { useState, useEffect, useRef } from "react";
import graph from "../assets/graph.webp";
import bag from "../assets/bag.webp";
import boyg from "../assets/boyg.webp";
import careerbg from "../assets/Rectangle17.svg";
import culture1 from "../assets/culture1.webp";
import culture2 from "../assets/culture2.webp";
import culture3 from "../assets/culture3.webp";
import culture4 from "../assets/culture4.webp";
import culture5 from "../assets/culture5.webp";
import culture6 from "../assets/culture6.webp";
import culture7 from "../assets/culture7.webp";
import culture8 from "../assets/culture8.webp";
import OurBlog from "./Blogs";
import { Briefcase, MapPin } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const allJobs = [
  {
    title: "Frontend Developer",
    department: "IT Engineering",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Backend Developer",
    department: "IT Engineering",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Financial Analyst",
    department: "Finance",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Marketing Specialist",
    department: "Marketing",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Sales Representative",
    department: "Sales",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "DevOps Engineer",
    department: "IT Engineering",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Account Manager",
    department: "Sales",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Content Strategist",
    department: "Marketing",
    experience: "2–3 years",
    location: "Noida",
  },
];

const categories = ["All", "IT Engineering", "Finance", "Marketing", "Sales"];

const Career = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  const filteredJobs =
    activeFilter === "All"
      ? allJobs
      : allJobs.filter((job) => job.department === activeFilter);

  const scrollContainerRef = useRef(null);
  const [scrollDirection, setScrollDirection] = useState("right");
  const scrollSpeed = 1;

  const images = [
    culture1,
    culture2,
    culture3,
    culture4,
    culture5,
    culture6,
    culture7,
    culture8,
    culture1,
    culture2,
  ];

  const topRowImages = images.slice(0, 5);
  const bottomRowImages = images.slice(5);

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let animationId;

    const scroll = () => {
      const maxScrollLeft =
        scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const currentScrollLeft = scrollContainer.scrollLeft;

      if (
        currentScrollLeft >= maxScrollLeft - 5 &&
        scrollDirection === "right"
      ) {
        setScrollDirection("left");
      } else if (currentScrollLeft <= 5 && scrollDirection === "left") {
        setScrollDirection("right");
      }

      scrollContainer.scrollLeft +=
        scrollDirection === "right" ? scrollSpeed : -scrollSpeed;

      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [scrollDirection]);

  return (
    <>
      <Navbar />

      <div className="career-blur-top-right-section"></div>

      <div className="career-banner-container">
        <div className="career-banner">
          <div className="banner-text fw-semibold text-start">
  <h1 className="" style={{ color: "#4b4b4b" }}>
    Grow Your Career<br />
    with ShubhPaisa
  </h1>
  <p className="mt-1 mb-0">
    Explore opportunities in<br />
    finance and innovation
  </p>
</div>

          <div className="banner-visuals">
            <div className="gradient-circle"></div>

            <div className="people-container">
              <img src={boyg} alt="Career professionals" />
            </div>

            <div className="briefcase-icon">
              <img src={bag} alt="Briefcase icon" />
            </div>

            <div className="graph-icon">
              <img src={graph} alt="Growth chart icon" />
            </div>
          </div>
        </div>
      </div>

      <div
        className="w-100 py-5 position-relative"
        style={{
          backgroundImage: `url(${careerbg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          borderTop: "none",
          marginTop: "0",
          paddingTop: "0",
          overflow: "hidden",
          border: "none",
        }}
      >
        <div className="py-5 text-center">
          <div className="container">
            <h2 className="fw-semobold mb-3">Why Shubh Paisa?</h2>

            <p
              className="mx-auto mb-3 px-3 px-md-0"
              style={{ maxWidth: "600px" }}
            >
              At Shubh Paisa, we don’t just offer jobs—we offer careers that
              grow with you. Join a team where ideas matter, impact is real, and
              finance meets innovation.
            </p>

            <div className="row justify-content-center align-items-stretch g-3 mt-5">
              <div className="col-12 col-md-3 d-flex">
                <div
                  className="card bg-white d-flex align-items-center justify-content-center m-auto career-card border-0 shadow-sm"
                  style={{
                    height: "200px",
                    width: "280px",
                    borderRadius: "12px",
                  }}
                >
                  <h5
                    className="card-title fw-semibold"
                    style={{
                      color: " #4B4B4B",
                      fontWeight: "500px",
                      fontSize: "18px",
                    }}
                  >
                     A Workplace <br /> That Inspires
                  </h5>
                  <p
                    className="mt-3 mb-4 text-muted fs-6"
                    style={{ color: " #616161" }}
                  >
                    {" "}
                    Collaborative, dynamic, and <br /> driven by purpose.
                  </p>
                </div>
              </div>

              <div className="col-12 col-md-3 d-flex">
                <div
                  className="card bg-white d-flex align-items-center justify-content-center m-auto career-card border-0 shadow-sm"
                  style={{
                    height: "200px",
                    width: "280px",
                    borderRadius: "12px",
                  }}
                >
                  <h5
                    className="card-title fw-semibold"
                    style={{
                      color: " #4B4B4B",
                      fontWeight: "500px",
                      fontSize: "18px",
                    }}
                  >
                    Growth <br /> Beyond Limits
                  </h5>
                  <p
                    className="mt-3 mb-4 text-muted fs-6"
                    style={{ color: " #616161" }}
                  >
                    {" "}
                    Training, mentorship, and <br /> endless learning
                    opportunities.
                  </p>
                </div>
              </div>

              <div className="col-12 col-md-3 d-flex">
                <div
                  className="card bg-white d-flex align-items-center justify-content-center m-auto border-0 shadow-sm"
                  style={{
                    height: "200px",
                    width: "280px",
                    borderRadius: "12px",
                  }}
                >
                  <h5
                    className="card-title fw-semibold"
                    style={{
                      color: " #4B4B4B",
                      fontWeight: "500px",
                      fontSize: "18px",
                    }}
                  >
                     A Culture <br /> of Impact
                  </h5>
                  <p
                    className="mt-3 mb-4 text-muted fs-6"
                    style={{ color: " #616161" }}
                  >
                    Work that transforms lives <br /> and futures.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="text-center py-5 bg-gradient"
        style={{ background: " #a18cd1" }}
      >
        <h2 className="text-white mb-4">Our Culture</h2>

        <div className="position-relative overflow-hidden w-100 p-0 m-0">
          <div
            ref={scrollContainerRef}
            className="d-flex flex-nowrap"
            style={{
              overflowX: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "none",
              paddingLeft: "150px",
              paddingRight: "150px",
              margin: 0,
              scrollBehavior: "auto",
            }}
          >
            {topRowImages.map((image, index) => (
              <div key={index} className="me-4 flex-shrink-0">
                <div className="d-flex flex-column gap-4">
                  <img
                    src={image}
                    className="img-fluid rounded-3 object-fit-cover"
                    style={{ height: "350px", width: "450px" }}
                    alt={`Culture image top ${index + 1}`}
                  />

                  {bottomRowImages[index] && (
                    <img
                      src={bottomRowImages[index]}
                      className="img-fluid rounded-3 object-fit-cover"
                      style={{ height: "350px", width: "450px" }}
                      alt={`Culture image bottom ${index + 1}`}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container-job position-relative">
        <div className="career-blur-top-right"></div>
        <div className="career-blur-bottom-left"></div>

        <div className="position-relative py-5" style={{ zIndex: 1 }}>
          <div className="container" style={{ maxWidth: "1200px" }}>
            <h2 className="text-center mb-4 fw-semibold">
              Join The Family, <br className="d-block d-sm-none" /> We're Hiring!
            </h2>

            <div className="category-scroll-wrapper mb-4">
              <div className="category-scroll px-2">
                <div className="scroll-inner d-flex gap-2">
                  {categories.map((category, index) => (
                    <button
                      key={index}
                      style={{ fontFamily: "poppins" }}
                      className={`btn rounded-pill border ${
                        activeFilter === category
                          ? "btn-primary text-white"
                          : "btn-light text-dark"
                      }`}
                      onClick={() => setActiveFilter(category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>
              {/* </div> */}

              <div
                className="job d-flex justify-content-center "
                style={{ maxWidth: "1200px" }}
              >
                <div className="row w-100 gx-4 gy-4 justify-content-center mt-3">
                  {filteredJobs.slice(0, 8).map((job, index) => (
                    <div
                      className="col-12 col-md-8 col-lg-6 col-xl-6"
                      key={index}
                    >
                      <div
                        className="card border-0 h-100 w-100"
                        style={{
                          width: "100%",
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          backdropFilter: "blur(12px)",
                          WebkitBackdropFilter: "blur(12px)",
                          borderRadius: "1rem",
                          boxShadow: `
                                      0px 8px 30px rgba(0, 0, 0, 0.05),
                                      0px 2px 12px rgba(0, 0, 0, 0.03)
                                    `,
                          padding: "1rem",
                          marginTop: "12px",
                        }}
                      >
                        <div className="d-flex flex-column flex-md-row justify-content-center align-items-center text-center text-md-start gap-3">
                          <div className="w-100 mt-2  ">
                            <h5 className="fw-semibold mb-2">{job.title}</h5>
                            <p className="text-muted mb-1 d-flex justify-content-center justify-content-md-start align-items-center">
                              <Briefcase size={18} className="me-2" />
                              {job.experience}
                            </p>
                            <p className="text-muted mb-0 d-flex justify-content-center justify-content-md-start align-items-center">
                              <MapPin size={18} className="me-2" />
                              {job.location}
                            </p>
                          </div>

                          <div className="text-center text-md-end w-100">
                            <Link
                              to="/jobmodal"
                              className="btn bg-primary text-white fw-semibold d-inline-flex align-items-center justify-content-center rounded-4 mt-2 px-3"
                              style={{
                                fontSize: "0.875rem",
                                whiteSpace: "nowrap",
                                fontFamily: "poppins"
                              }}
                            >
                              Apply Now{" "}
                              <i className="fas fa-arrow-right ms-2 mt-1"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OurBlog />
      <Footer />
    </>
  );
};

export default Career;
